import { Fetch } from '../../shared/types';
import { ZapierSession } from '@zapier/universal-layout';

export type Options = {
  zapId: String;
  accountId: ZapierSession['currentAccountId'];
};

export const runEnablementChecks = (
  fetch: Fetch,
  { zapId, accountId }: Options
): Promise<any> =>
  fetch(
    `/api/gulliver/storage/v1/zaps/${zapId}/check?account_id=${accountId}`,
    {
      method: 'POST',
    }
  );

export default runEnablementChecks;
